import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { FC, useEffect, useMemo, useRef } from 'react';

export type DateRangeValue = {
  start: Dayjs | null;
  end: Dayjs | null;
};

interface CustomPickerDay extends PickersDayProps<Dayjs> {
  range: DateRangeValue;
}

const CustomPickerDay: FC<CustomPickerDay> = ({
  range,
  day,
  selected,
  ...rest
}) => {
  const pickerRef = useRef<HTMLButtonElement>(null);

  const pickerClassName = useMemo(() => {
    if (range.start && range.end && day >= range.start && day <= range.end) {
      return 'Mui-highlighted';
    }
    return undefined;
  }, [range]);

  const pickerSelected = useMemo(
    () => (range.start ? !day.diff(range.start) : selected),
    [range, selected]
  );

  useEffect(() => {
    if (range.end) {
      pickerRef.current?.blur();
    }
  }, [range]);

  return (
    <PickersDay
      {...rest}
      ref={pickerRef}
      day={day}
      className={pickerClassName}
      selected={pickerSelected}
    />
  );
};

export default CustomPickerDay;
